import "../ComponentToPrint/ComponentToPrint.css";
import DataGridSummaries from "../DataGridSummary/DataGridSummaries";
import SummariesPieChart from "../SummariesPieChart/SummariesPieChart";
import { Grid } from "@mui/material";

const AvatarGray = "#bdbdbd";

export default function ChartGrid({isPrinting, chartData, summaryType, field, isTreatment, isActual, isAll, features, keyToUse,
}) {
  return (
    <div className="report-page" key={keyToUse}>
      <>
        <Grid
          item
          size={12}
          container
          direction="row"
          style={{
            borderSize: "1px",
            borderStyle: "solid",
            borderColor: AvatarGray,
            borderRadius: "7px",
          }}
        >
          <Grid item size={12} className="incident-list-sort-panel print-column">
            <DataGridSummaries isTreatment={isTreatment} isActual={isActual} isAll={isAll} chartData={chartData} label={`${summaryType}`} features={features} keyToUse={`${field} ${summaryType}`} isPrinting={isPrinting} />
          </Grid>
          <Grid
            item
            size={12}
            className="incident-list-sort-panel no-print-column"
            sx={{ marginTop: "35px", paddingTop: "0px" }}
          >
            <SummariesPieChart data={features} label={`${summaryType}`} isTreatment={isTreatment} isActual={isActual} isAll={isAll} />
          </Grid>
        </Grid>
      </>
    </div>
  );
}
